import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { FinancialStatementThreeYearsAgoFullYearRuleset } from '../../business/ruleset';
import { taxDocuments } from '../../form_models/loanFormModel';

const { financialStatementThreeYearsAgoFullYear } = taxDocuments;

export class FinancialStatementThreeYearsAgoFullYearValidation
  implements ValidationSchema
{
  public name = financialStatementThreeYearsAgoFullYear.name;
  public label =
    financialStatementThreeYearsAgoFullYear.getLabel(defaultApplicantName);
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = FinancialStatementThreeYearsAgoFullYearRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    return FileNameValidationSchema(
      financialStatementThreeYearsAgoFullYear.name,
      required
    );
  }
}
export default new Validation(
  new FinancialStatementThreeYearsAgoFullYearValidation()
);
